import { UserDetails } from '../../../data/mockdata';
import apiClient from '../ApiClient';
import { redirectToLoginPage } from '../../../helper';

const UserDetailsServices = {
  getUserDetails: async (_instance) => {
    try {
      return (await apiClient.get('/getUserDetails')).data;
    } catch (error) {
      console.error('Error fetching users:', error);
      // if (error.response && error.response.status === 401) {
      //   redirectToLoginPage(instance);
      // }
      return UserDetails; // Return mock data as a fallback
    }
  },

  updateLastView: async (params, instance) => {
    try {
      return (await apiClient.post('/updateLastView', params)).data;
    } catch (error) {
      console.error('Error updating last view:', error);
      if (error.response && error.response.status === 401) {
        redirectToLoginPage(instance);
      }
      return null; // Graceful fallback
    }
  },

  createAlertsWithUser: async (params, instance) => {
    try {
      return (await apiClient.post('/createAlertsWithUser', params)).data;
    } catch (error) {
      console.error('Error creating alerts with user:', error);
      if (error.response && error.response.status === 401) {
        redirectToLoginPage(instance);
      }
      return null; // Graceful fallback
    }
  },

  createAlertsWithThresholdUser: async (params, instance) => {
    try {
      return (await apiClient.post('/createAlertsWithThresholdUser', params)).data;
    } catch (error) {
      console.error('Error creating alerts with threshold user:', error);
      if (error.response && error.response.status === 401) {
        redirectToLoginPage(instance);
      }
      return null; // Graceful fallback
    }
  },
};

export default UserDetailsServices;
